import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { FeedbackPage } from '@/features/feedback/list-page';
import { feedbackSearchSchema } from '@/features/feedback/search';

export const Route = createFileRoute('/_authenticated/operations/feedback')({
  validateSearch: (search: Record<string, unknown>) =>
    feedbackSearchSchema.parse(search),
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'feedback:read'),
  component: FeedbackRoutePage,
});

function FeedbackRoutePage() {
  const { status } = Route.useSearch();
  return <FeedbackPage key={status ?? 'all'} initialStatus={status} />;
}
